/* eslint-disable @typescript-eslint/camelcase */
import * as React from 'react';
import { autorun } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as cookies from 'browser-cookies';

import { ErrorBoundary } from 'bernie-view';
import { ContextStore } from 'bernie-core';

import { AdvertisingStore, SearchFormStore, SearchCriteriaStore } from 'stores';

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    meso: any;
  }
}
interface IntentMediaProps {
  advertisingStore?: AdvertisingStore;
  context?: ContextStore;
  searchFormStore?: SearchFormStore;
  searchCriteriaStore?: SearchCriteriaStore;
}
@inject('context', 'searchFormStore', 'advertisingStore', 'searchCriteriaStore')
@observer
export class IntentMedia extends React.Component<IntentMediaProps> {
  private haltPageContenxtInfo: () => void;
  public componentDidMount() {
    this.haltPageContenxtInfo = autorun(() => {
      let intentMediaData = {};
      window.meso = window.meso || {};
      window.meso.adcontext = window.meso.adcontext || [];
      const { advertisingStore, context, searchFormStore, searchCriteriaStore } = this.props;
      const sharedGuidsData = this.mapSharedGuidsData(context);
      const searchContextData = this.mapSearchContextData(searchCriteriaStore, searchFormStore);
      const userContextData = this.mapUserContextData(context, advertisingStore);
      const updatedIntentMediaData = {
        ...sharedGuidsData,
        ...searchContextData,
        ...userContextData
      };
      intentMediaData = updatedIntentMediaData;
      window.meso.adcontext.push(intentMediaData);
    });
  }

  private mapSharedGuidsData(context: ContextStore) {
    return {
      publisher_session_id_hashed: '',
      publisher_session_id: '',
      publisher_user_id_hashed: '',
      publisher_user_id: context.deviceId ? context.deviceId.toUpperCase() : ''
    };
  }
  private mapUserContextData(context: ContextStore, advertisingStore: AdvertisingStore) {
    const deviceType = context.deviceInformation.mobile
      ? 'Mobile'
      : context.deviceInformation.tablet
      ? 'Tablet'
      : 'Desktop';
    // ToDo: Update the site country and experiment once data is recieved.

    return {
      is_logged_in_user: context.user.authState === 'ANONYMOUS' ? 'N' : 'Y',
      is_member: context.user.isRegistered ? 'Y' : 'N',
      expedia_cookie_aspp: cookies.all(),
      site: context.site.brand,
      show_ads: context.site.optInPrivacyInfo.canTrack ? 'Y' : 'N',
      show_exit_units: 'Y',
      show_overlay: 'Y',
      display_format_type: deviceType,
      page_view_type: 'LIST',
      product_category: 'flights',
      referrer_channel: 'Brand',
      referrer_source: 'DTI',
      site_country: 'US',
      site_currency: context.currency,
      site_reporting_value_06: advertisingStore.pageName,
      site_reporting_value_01: '32719_1',
      cache_buster: Math.floor(Math.random() * 10000000)
    };
  }

  private mapSearchContextData(searchCriteriaStore: SearchCriteriaStore, searchFormStore: SearchFormStore) {
    const travelerDetails = searchCriteriaStore.searchCriteria.travelerDetails;
    let adults = 0;
    let children = 0;
    for (const travelerDetail of travelerDetails) {
      if (travelerDetail && travelerDetail.travelerType === 'ADULT') {
        adults = travelerDetail.count;
      } else if (travelerDetail && travelerDetail.travelerType === 'CHILD') {
        children = travelerDetail.count;
      }
    }
    const searchForm = searchFormStore && searchFormStore.searchForm;
    const destinationLocation = searchForm && searchForm.journeys[0].destinationLocation.airportCode;
    const originLocation = searchForm && searchForm.journeys[0].originLocation.airportCode;
    const departureDate = searchForm.journeys[0].departureDate;
    const returnDate = searchForm.journeys[0].returnDate;
    const travelDateStart =
      departureDate && departureDate.date && departureDate.date.isoFormat
        ? departureDate.date.isoFormat.replace(/-/g, '')
        : '';
    const travelDateEnd =
      returnDate && returnDate.date && returnDate.date.isoFormat
        ? '' + returnDate.date.isoFormat.replace(/-/g, '')
        : '';

    return {
      adults,
      children,
      flight_destination: destinationLocation,
      flight_origin: originLocation,
      travelers: adults + children,
      travel_date_start: travelDateStart,
      travel_date_end: travelDateEnd,
      trip_type: this.props.searchCriteriaStore.searchCriteria.flightsSearchContext.tripType
    };
  }

  public render() {
    return (
      <ErrorBoundary label="meso.intentmedia.ad">
        <meso-intent-media />
      </ErrorBoundary>
    );
  }
}
